// @flow
import type { StudySetState } from './types';
import {
  sortingType,
  learningMode,
} from '../types';

const GAME_FLIP = 'Flip';

const initialState: StudySetState = {
  sessionCreated: false,
  sessionLoading: false,
  studyMode: learningMode.flip,
  nextScreen: GAME_FLIP,
  inReverseMode: false,
  redirectUrl: null,
  sessionCreationFailed: false,
  progressBarValue: 0,
  answerEventInProgress: false,
  hasMultipleContent: false,
  currentSortType: {
    name: sortingType.ORIGINAL,
    isAscending: false,
  },
  sessionId: null,
  overallPermission: '',
  isSchedule: false,
  sessionType: 'normal',
};

export default initialState;
